import * as React from "react";
import { ApiClient, CoreApp, ThemeProvider } from "@erp/ui";
import { DEVELOPMENT_API_BASE_URL } from "./config";

export function App({
  baseUrl = DEVELOPMENT_API_BASE_URL,
}: {
  baseUrl?: string;
}): React.JSX.Element {
  const client = React.useMemo(() => new ApiClient(baseUrl, "web"), [baseUrl]);
  const resetToken =
    typeof window === "undefined"
      ? undefined
      : (new URLSearchParams(window.location.search).get("token") ?? undefined);
  return (
    <ThemeProvider>
      <CoreApp
        client={client}
        resetToken={resetToken}
        downloadInventoryCsv={(csv) => {
          const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
          const url = URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.download = "inventario.csv";
          anchor.click();
          URL.revokeObjectURL(url);
        }}
      />
    </ThemeProvider>
  );
}
